module.exports = __webpack_public_path__ + "img/pp1.8a524533.png";